import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import { getSuitableBorderColorString } from '~/_shared/utils/colors/colors.helpers';

export const containerStyle = (theme: Theme) => css({
  backgroundColor: theme.backgroundColors.primary,
});

export const labelStyle = css({
  fontSize: '12px',
  marginBottom: '4px',
});

export const flexContainerStyle = css({
  display: 'flex',
  alignItems: 'center',
});

export const squareStyle = (color: string, backgroundColor: string) => css({
  marginRight: '8px',
  border: `${getSuitableBorderColorString(color, backgroundColor)} 1px solid`,
});

export const squarePrefixStyle = (color: string, theme: Theme) =>
  squareStyle(color, theme.dropdownColors.optionBackground);

export const squareMainStyle = (color: string, theme: Theme) =>
  squareStyle(color, theme.backgroundColors.primary);

export const colorWheelStyle = css({
  height: 16,
  width: 16,
  paddingRight: 8,
});

export const colorPickerStyle = css({
  marginLeft: '6px',
  marginRight: '20px',
});

export const dropdownContainerStyle = css({
  flexGrow: 1,
});

export const dropdownTriggerStyle = css({
  height: '32px',
});
